import Skeleton from 'Components/Atoms/Skeleton/Skeleton';

export default function CardInvoiceSkeleton() {
    return (
        <div className="grid grid-cols-[32px_1fr_auto] sm:grid-cols-[32px_2fr_1fr_1fr] items-center gap-3 p-3 bg-white ring ring-gray-200 rounded-lg">
            <Skeleton className="w-8 h-8 rounded-full" />
            <div className="overflow-hidden">
                <Skeleton className="h-4 w-32 mb-1" />
                <Skeleton className="h-3 w-20" />
            </div>
            <div className="hidden sm:block">
                <Skeleton className="h-3 w-16 mb-1" />
                <Skeleton className="h-3 w-20" />
            </div>
            <div className="flex justify-end">
                <Skeleton className="h-4 w-24" />
            </div>
        </div>
    );
}
